export const enum SeoBlockType {
  SeoBlock = 'seo_block',
  TableOfContent = 'table_of_content',
  TabBar = 'tab_bar',
}
